import { createGetAllAPI, createGetAPI, createPatchAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';

import { BASE_URL } from '../constants/api';

const { useGetAll: useStudentsGetAll, invalidate: invalidateStudents } = createGetAllAPI({
  getURL: query => {
    return `${BASE_URL}/students/?${stringify(query)}`;
  },
});

const { useGet: useStudentGet, invalidate: invalidateStudentGet } = createGetAPI({
  getURL: id => {
    return `${BASE_URL}/students/${id}/v1/account/`;
  },
});

const { useGetAll: useSessionsGetAll, invalidate: invalidateSessions } = createGetAllAPI({
  getURL: (id, query) =>
    `${BASE_URL}/students/student-classrooms/?student_id=${id}&${stringify(query)}`,
});

const {
  useGetAll: useStudentPaymentGetAll,
  invalidate: invalidateStudentPaymentGetAll,
} = createGetAllAPI({
  getURL: id => `${BASE_URL}/students/${id}/student-payment-link`,
});

const {
  useGetAll: useStudentCoursesGetAll,
  invalidate: invalidateStudentCoursesGetAll,
} = createGetAllAPI({
  getURL: (id, query) => `${BASE_URL}/student-courses/${id}/?${stringify(query)}`,
});

const { usePatch: useStudentCoursePatch } = createPatchAPI({
  getURL: studentId => `${BASE_URL}/student-courses/${studentId}`,
});

const {
  useGetAll: useStudentAddOnsGetAll,
  invalidate: invalidateStudentAddOnsGetAll,
} = createGetAllAPI({
  getURL: (id, query) =>
    `${BASE_URL}/students/${id}/student-add-ons/?${stringify(query)}`,
});

const { useGet: useStudentPtmReportGet } = createGetAPI({
  getURL: id => `${BASE_URL}/ptm/${id}`,
});

const { useGet: useStudentLeavesHistoryGet } = createGetAPI({
  getURL: id => `${BASE_URL}/leaves/${id}/history?user_type=STUDENT`,
});

const { usePatch: useLastUpdatedOnPatch } = createPatchAPI({
  getURL: parentId => `${BASE_URL}/parents/${parentId}`,
});

const { usePatch: useSuspendCoursePatch } = createPatchAPI({
  getURL: courseId => `${BASE_URL}/student-course/${courseId}/dormant/`,
});

const { usePatch: useActivateCoursePatch } = createPatchAPI({
  getURL: () => `${BASE_URL}/student-course/activate-courses`,
});

const { usePatch: useDemoClassroomPatch } = createPatchAPI({
  getURL: studentClassroomId =>
    `${BASE_URL}/classroom/demo-classrooms/${studentClassroomId}/`,
});

export {
  useStudentsGetAll,
  invalidateStudents,
  useStudentGet,
  useLastUpdatedOnPatch,
  invalidateStudentGet,
  useStudentPaymentGetAll,
  invalidateStudentPaymentGetAll,
  useSessionsGetAll,
  invalidateSessions,
  useStudentPtmReportGet,
  useStudentAddOnsGetAll,
  invalidateStudentAddOnsGetAll,
  useStudentCoursesGetAll,
  invalidateStudentCoursesGetAll,
  useSuspendCoursePatch,
  useActivateCoursePatch,
  useStudentLeavesHistoryGet,
  useStudentCoursePatch,
  useDemoClassroomPatch,
};
